/* eslint-disable no-restricted-globals */
import * as React from 'react';
import { AppHeader } from './AppHeader/AppHeader';
import { AppFooter } from './AppFooter';
import { QuickViewDrawer, QUICK_VIEW_WIDTH } from '../userDashboard/quickView/QuickViewDrawer';
import { QuickViewTourController } from '../userDashboard/quickView/QuickViewTourController';
import { AiDocumentChatProvider } from '../documentAi/AiDocumentChatContext';
import { AiChatDialogRoot } from '../documentAi/AiChatDialogRoot';
import { AiChatMinimizedBar } from '../documentAi/AiChatMinimizedBar';
import { HEADER_HEIGHT, FULL_WIDTH, SEMI_WIDTH } from './MainDrawer';
import glamorous, { ThemeProvider } from 'glamorous';
import { Switch, Route, Router, matchPath } from 'react-router-dom';
import { mainTheme } from '../Theme';
import { initializeIcons } from '@uifabric/icons';
// Explicit bug report: the 'history/createBrowserHistory' subpath import logs a deprecation
// warning on every load (history v4 itself, not this app's own code) - the main package's own
// named export is the same function and avoids it. @ts-ignore still needed though: the
// installed @types/history@5.0.0 is a stub for history v5 (which ships its own types), not a
// match for the actual installed history@4.10.1 here, so TS still can't see a declaration for
// the root 'history' module either way.
// @ts-ignore - see above, not a type issue this change introduced
import { createBrowserHistory } from 'history';
import { Dashboard, 
         MatterSummary,
         MatterSummaryDrillDown,
         MatterDetails,         
         Redirect,
         RvPrint,
         RvPrint2,
         Logout,
         RvDashboardOld,
         Settings,
         LeapProvisioning,
         LeapSignIn,
         LeapProvisioningInProgress,
         VerifyNewUser,
         LeapAccessResetSignIn,
         LeapAccessReset,
         Unauthorised,
         ClientAndContactDetails,
         TimeslipPage,
         AutoSignIn,
         ExternalEnquiry,
         UserDashboard,
         RvAdminDashboard,
         UserListPage,
         TimesheetActivityPage,
         MessageActivityPage,
         RoleSummaryPage,
         LearnMorePage,
         InvoiceSummaryPage,
         HelpConfigurationPage,
         UserConfigurationPage,
         ReferrersPage,
         CreateEnquiryPage,
         EmailTemplatesConfigurationPage,
         LookupConfigurationPage,
         ConfigurationDashboardPage,
         FeeEarnerDashboardPage,
         Home,
         LawyerDashboardPage,
         LeadsDashboardPage,
         EnquirySummaryPage,
         FeatureAccessConfigurationPage,
          FeatureLayoutConfigurationPage,
         FeatureLicenceConfigurationPage,         
         LeadsDetailPage,
         LoginActivityChartPage,
         LoginActivityPage,
         MailingListPage,
         MatterAccessChartPage,
         MatterAccessPage,
         MatterManagementPage,
         NameAccessChartPage,
         NameAccessPage,
         NameSummaryPage,
         ReportCatalogInformation,
         ReportInformation,
         ReportsCatalogPage,
         ReportsPage,
         ReportViewer,
         SplashScreenConfigurationPage,
         StaffBillingSummaryPage,
         StaffSummaryPage,
         TasksSummaryPage,
         TimelinesChartPage,
         TimesheetDrilldownPage,
         TimesheetPage,
         UploadDocumentDialog,
         TaskDashboardPage,
         TaskSummaryDrilldownPage,
         BrandConfigurationPage,
         EventsAndCampaignsPage,
         ClientDashboardPage,
         GeneralMaterialConfigurationPage,
         CrmResourceCenterPage,
         AcuityResourceCenterPage,
         MattersResourceCenterPage,
         TimesheetResourceCenterPage,
         TaskResourceCenterPage,
         RoleSecurityConfigurationPage,
         EventsAndCampaignsAttendeePage,
         ClientDocumentsPage,
         DashboardAccessPage,
         UserDashboardActivityListPage,
         MatterColumnSecurityConfigurationPage,
         NotesSummaryPage,
         MarketingListAccessPage,
         MarketingListAccessChartPage,
         EmailSendFailurePage,
         EmailSendFailureChartPage,
         NotesSummaryDrilldownPage,
         WriteOffOnSummaryDrilldownPage,
         UnbilledFeeEarnerDrilldownPage,
         UserAIActivityChartPage,
         UserAIActivitytPage,
         UserOutlookAddinUsagePage,
         OutlookAddinUsagePage,
         SmsUsageLoggingPage,
         SmsUsageLoggingChartPage,
         EmailSendLoggingPage,
         SmokeballAccessReset,
         SmokeballAccessResetSignIn,
         SmokeballSignIn,
         SmokeballProvisioning,
         ActionStepSignIn,
         ActionStepAccessResetSignIn,
         ActionStepProvisioning,
         ActionStepAccessReset,
         AffinitySignIn,
         AffinityAccessResetSignIn,
        //  AffinityProvisioning,
         AffinityAccessReset,
         EnquiryDataCollectionFormPage,
         MatterPublishingRulesPage,
         MarketingAutomationPage,
         SampleMarketingAutomationPage
        } from './LoadComponentAsync';
import EventSystem from '../EventSystem';
import UrlViewer from './UrlViewer';
import { UploadMatterDocumentNotification } from '../matterSummary/MatterSummaryRepository';
import { UserFeature, UserFeatureEnum } from '../types/UserFeature';
import { client } from '..';
import { showNotification } from '../App';
import { Subscription } from 'apollo-client/util/Observable';
import Login from './Login';
import { SupportEmailDialog, SupportDialogCustomization } from '../home/Support/SupportEmailPage';
import IntegrationConfigurationPage from '../integrationConfiguration/IntegrationConfigurationPage';
import CalendlyAuthCallbackPage from '../integrationConfiguration/CalendlyAuthCallbackPage';
import FirmSettingConfigurationPage from '../firmSettingConfiguration/FirmSettingConfigurationPage';
import FirmStructureConfigurationPage from '../firmStructureConfiguration/FirmStructureConfigurationPage';
import ApplicationSettingsPage from '../applicationSettings/ApplicationSettingsPage';
import { TaskflowBuilderPage } from '../taskflowBuilder/TaskflowBuilderPage';
import InstructMatterFormDialog from '../instructMatter/InstructMatterFormDialog';
import { CreateInstructMatterSubscription, CreatePendingMattersSubscription } from '../instructMatter/InstructMatterRepositories';
import TimesheetTimerDrawer from '../timesheetTimer/TimesheetTimerDrawer';
import GeneralMaterialPage from '../GeneralMaterial/GeneralMaterialPage';
import gql from 'graphql-tag';
import i18n from '../i18n';
import AppMenu from './AppHeader/AppMenu';
import { getLanguageCodeByCountry } from '../locales/common';
import { ApolloQueryResult } from 'apollo-client';
import { LocalStorageEnum } from '../enums/LocalStorageEnum';
import EnquiryCustomFieldsPage from '../enquiryCustomFields/EnquiryCustomFieldsPage';
import SmokeballProvisioningInProgress from './smokeball/SmokeballProvisioningInProgress';
import ActionStepProvisioningInProgress from './actionStep/ActionStepProvisioningInProgress';
import SessionExpiryWarningDialog from './SessionExpiryWarningDialog';
import AffinityProvisioningInProgress from './affinity/AffinityProvisioningInProgress';
import ExternalAccessValidation from '../externalAccess/ExternalAccessValidation';
import { ApplicationTerminologyData, ApplicationTerminoLogyQuery } from '../applicationSettings/tabs/FieldLabelsTab';
// import { TestComponentPage } from '../testComponent/TestComponentPage';

var NotificationSystem = require('react-notification-system');
export const browserHistory = createBrowserHistory();

// Same module-singleton pattern as App.tsx's own notificationSystem/showNotification -
// registered by AppContent itself (componentDidMount/componentWillUnmount below), called by
// any component that needs to open the support dialog pre-filled with technical detail (e.g.
// AiChatDialog.tsx's own error banner) without prop-drilling through every layer in between.
// Explicit request: an optional customization object lets a caller also reframe the dialog's
// own heading/subtitle/description for its own context (e.g. NotificationCenter.tsx's release
// note "want to know more" button) - omitted, every other caller keeps SupportEmailDialog's own
// default wording unchanged.
let requestSupportListener: ((initialNote: string, customization?: SupportDialogCustomization) => void) | null = null;
export const requestSupportWithNote = (initialNote: string, customization?: SupportDialogCustomization) => {
    if (requestSupportListener) {
        requestSupportListener(initialNote, customization);
    }
};

const SiteParent = glamorous.div({
    display: 'flex',
    minHeight: '100vh',
    flexDirection: 'column',
    [`& > .${`header`}`]: {
        boxShadow: '0 1px 2px 0 rgba(81,115,255,0.17)',
        position: 'fixed',
        background: '#fff',
        width: '100%',
        // Above MUI's own theme.zIndex.drawer (1200) - explicit bug report: UserCardV2.tsx's
        // own user-menu Popper uses disablePortal, so it paints inside the header's own
        // stacking context instead of at the document root. At the previous 1009 that meant
        // the entire header (menu included) painted BENEATH any Drawer using MUI's default
        // z-index - QuickViewDrawer.tsx's own Paper, pinned (variant="permanent") or not,
        // set exactly that, so the header's user-menu/logout dropdown was rendering hidden
        // behind it. Still below theme.zIndex.modal (1300) so an actual modal dialog still
        // renders above the header as expected.
        zIndex: 1250,
        height: HEADER_HEIGHT,
    },
    '& .timeslip-header': {
        display: 'none',
    },
    '& .custom-site-content': {
        paddingTop: HEADER_HEIGHT,
    },
    [`.${`site-onprint`}`]: {
        [`& .${`user-list-wrapper`}`]: {
            [`& .${`container-userlist`}`]: {
                display: 'none'
            },
            [`& .${`container-usercontent`}`]: {
                padding: 0,
                [`& .${`panel-container`}`]: {
                  display: 'none'
                },            
                [`& .${`content-wrapper`}`]: {
                    padding: 0
                },   
                [`& .${`table-container`}`]: {
                  padding: 0
                }          
            }                  
        },
        [`& .${`mattersummry-wrapper`}`]: {
            [`& .${`banner-container`}`]: {
                display: 'none'
            },
            [`& .${`content-wrapper`}`]: {
                padding: 0,
            },
            [`& .${`content-container`}`]: {
                padding: 0,
            },        
            [`& .${`butoncontainer`}`]: {
                display: 'none'
            },
            [`& .${`summaryview-wrapper`}`]: {
                padding: 0
            },
        }          
    }    
});

interface AppProps {
    // tslint:disable-next-line: no-any
    notificationSystem?: any;
}

interface AppState {
    isAuthenticated: boolean;
    tenantId: string;
    showMenu: boolean;
    dockMode: 'closed' | 'full' | 'semi';
    isPrint?: boolean;
    isForceToChangePass?: boolean;
    isUploadDialogOpen: boolean;
    isSupportDialogOpen: boolean;
    /** Pre-fills SupportEmailDialog's own note field - set by requestSupportWithNote (below),
     * cleared on close so a later plain "Get Support" header click doesn't inherit a stale note. */
    supportDialogInitialNote: string;
    /** Optional heading/subtitle/description override for SupportEmailDialog - lets a caller
     * (e.g. NotificationCenter.tsx's release-note "want to know more" button) reframe the same
     * dialog/send-email flow for its own context, without changing the plain header "Get
     * Support" button's own wording. undefined falls back to SupportEmailDialog's own defaults -
     * cleared on close for the same reason as supportDialogInitialNote above. */
    supportDialogCustomization?: { title?: string; subtitle?: string; description?: string };
    isInstructMatterDialogOpen: boolean;
    isTimerDrawerOpen: boolean;
    isQuickViewOpen: boolean;
    isQuickViewPinned: boolean;
    isQuickViewTourRunning: boolean;
}

export class AppContent extends React.Component<AppProps, AppState> { 
    private unAuthenticatedUserKey: string;
    private authenticatedUserKey: string;
    private uploadMatterDocumentSubscription?: Subscription;
    private pendingMatterSubscription?: Subscription;
    private createInstructMatterSubscription?: Subscription;
    private isSubscribed?: boolean;
    private historyUnlisten?: () => void;

    // tslint:disable-next-line:no-any
    constructor(props: AppProps, state: AppState) {
        super(props, state);
        this.onUploadDocuments = this.onUploadDocuments.bind(this);
        this.onUploadClose = this.onUploadClose.bind(this);
        this.onRequestSupport = this.onRequestSupport.bind(this);
        this.onRequestSupportClose = this.onRequestSupportClose.bind(this);
        this.onLogin = this.onLogin.bind(this);
        this.onLogout = this.onLogout.bind(this);
        this.onTenant = this.onTenant.bind(this);
        this.onShowMenu = this.onShowMenu.bind(this);
        this.getAppHeaderKey = this.getAppHeaderKey.bind(this);
        this.onClickInstructMatter = this.onClickInstructMatter.bind(this);
        this.onInstructMaterClose = this.onInstructMaterClose.bind(this);
        this.subscribePendingMatter = this.subscribePendingMatter.bind(this);
        this.subscribeInstructMatter = this.subscribeInstructMatter.bind(this);
        this.onToggleDrawer = this.onToggleDrawer.bind(this);
        this.onToggleQuickView = this.onToggleQuickView.bind(this);
        this.onToggleQuickViewPin = this.onToggleQuickViewPin.bind(this);
        this.onQuickViewTourRunningChange = this.onQuickViewTourRunningChange.bind(this);
        this.getDefaultSetting = this.getDefaultSetting.bind(this);
        this.onCycleDock = this.onCycleDock.bind(this);
        this.onCloseDock = this.onCloseDock.bind(this);
        this.onMenuClose = this.onMenuClose.bind(this);
        this.getDefaultApplicationTerminology = this.getDefaultApplicationTerminology.bind(this);

        this.unAuthenticatedUserKey = Math.random().toString();
        this.authenticatedUserKey = Math.random().toString();

        var tenantID = sessionStorage.getItem('tenantId');
        var accessToken = sessionStorage.getItem('accessToken');
        var mfaCodeRequired = sessionStorage.getItem('mfaCodeRequired');
        
        let isAuthenticated = (mfaCodeRequired === null 
            ? accessToken != null && accessToken !== '' 
            : (mfaCodeRequired !== null && mfaCodeRequired !== '1') && (accessToken != null && accessToken !== ''));

        if (!tenantID) { tenantID = ''; }

        const savedDock = localStorage.getItem('appMenuDock') as 'closed' | 'full' | 'semi' | null;
        const dockMode = savedDock && savedDock !== 'closed' ? savedDock : 'closed';
        // Same "remembers" behaviour as appMenuDock above - if Quick View was pinned open
        // last session, it reopens pinned open again on this one, rather than starting closed.
        const isQuickViewPinned = localStorage.getItem('quickViewPinned') === 'true';
        this.state = {
            isAuthenticated: isAuthenticated,
            tenantId: tenantID,
            showMenu: dockMode !== 'closed',
            dockMode: dockMode,
            isPrint: false,
            isForceToChangePass: false,
            isUploadDialogOpen: false,
            isSupportDialogOpen: false,
            supportDialogInitialNote: '',
            supportDialogCustomization: undefined,
            isInstructMatterDialogOpen: false,
            isTimerDrawerOpen: false,
            // isAuthenticated && - nothing clears the pin preference on logout, so without
            // this an unauthenticated visit (e.g. the login screen, reached right after a
            // previous session had it pinned) would seed this true too - the actual render
            // site gates on isAuthenticated as well (belt and suspenders), but seeding it
            // false here to begin with avoids state claiming "open" while nothing renders.
            isQuickViewOpen: isAuthenticated && isQuickViewPinned,
            isQuickViewPinned: isQuickViewPinned,
            isQuickViewTourRunning: false
        };

        // initializeIcons(undefined, { disableWarnings: true });
        // to fix issues - https://github.com/microsoft/fluentui/issues/33596
        // Old URLS - https://spoppe-b.azureedge.net/files/fabric-cdn-prod_20210407.001/assets/icons/fabric-icons-2-63c99abf.woff	
        initializeIcons(
            'https://res.cdn.office.net/files/fabric-cdn-prod_20240129.001/assets/icons/',
        );

        EventSystem.on('onprint:true', () => {
            this.setState({isPrint: true});
        });

        EventSystem.on('onprint:false', () => {
          this.setState({isPrint: false});
        });   
        
        let hideHeadFooter = location.pathname.toLowerCase() === '/leapprovisioninginprogress' 
                || location.pathname.toLowerCase() === '/leapprovisioning'
                || location.pathname.toLowerCase() === '/leapaccessreset'
                || location.pathname.toLowerCase() === '/feeearnerdashboard/leap'
                || location.pathname.toLowerCase() === '/dashboard/leap'
                || location.pathname.toLowerCase() === '/enquiriessummary/leap'
                || location.pathname.toLowerCase() === '/enquiriesdashboard/leap'
                || location.pathname.toLowerCase() === '/clientsandcontacts/leap'
                || location.pathname.toLowerCase() === '/referrers/leap'
                || location.pathname.toLowerCase() === '/mailinglist/leap'
                || location.pathname.toLowerCase().includes('/leapreports/')
                || location.pathname.toLowerCase() === '/smokeballprovisioninginprogress' 
                || location.pathname.toLowerCase() === '/smokeballprovisioning'
                || location.pathname.toLowerCase() === '/smokeballaccessreset'
                || location.pathname.toLowerCase() === '/actionstepprovisioninginprogress' 
                || location.pathname.toLowerCase() === '/actionstepprovisioning'
                || location.pathname.toLowerCase() === '/actionstepaccessreset';

        if (hideHeadFooter) {
            // tslint:disable-next-line:no-any
            window.addEventListener('message', function(event: MessageEvent<any>) { 
                
                // tslint:disable-next-line: no-shadowed-variable
                var accessToken = event.data.accessToken;

                if (accessToken) {
                    
                    var existingAccessToken = sessionStorage.getItem('accessToken');

                    if (existingAccessToken === null) {
                        sessionStorage.setItem('accessToken', accessToken);

                        // Reload the page to reset the Graphql AuthLink. Other approaches didn't work.
                        window.location.reload();
                    }
                }     
            // tslint:disable-next-line: align           
            }, false);
        }
    }   

    public componentDidMount() {
        if (this.state.isAuthenticated && !location.pathname.startsWith('/externalAccess/')) {
            if (!this.isSubscribed) {
                this.isSubscribed = true;
                this.subscribeToUploadMatterDocument();
            }
            this.subscribePendingMatter();
            this.subscribeInstructMatter();
            this.getDefaultApplicationTerminology();
            // this.getDefaultSetting();
        }

        // Quick View (userDashboard/quickView/QuickViewDrawer.tsx) closes itself the
        // moment the person actually navigates - registered unconditionally (not gated
        // behind isAuthenticated above) since this only ever fires from a real pathname
        // change, never from Quick View's own open/close state changes. Pinned is the
        // explicit exception - the whole point of pinning it (like the nav sidebar's own
        // dockMode) is to keep it open and visible while navigating around and performing
        // other operations, not just while sitting still on one page.
        this.historyUnlisten = browserHistory.listen(() => {
            if (this.state.isQuickViewOpen && !this.state.isQuickViewPinned) {
                this.setState({ isQuickViewOpen: false });
            }
        });

        // Same registration pattern as App.tsx's own notificationSystem/showNotification - lets
        // a deeply nested component (e.g. AiChatDialog.tsx, portalled far outside this tree) open
        // the support dialog pre-filled with technical detail, without prop-drilling through
        // every layer in between.
        requestSupportListener = (initialNote: string, customization?: SupportDialogCustomization) =>
            this.onRequestSupport(initialNote, customization);
    }

    public componentWillUnmount() {
        requestSupportListener = null;
        if (this.uploadMatterDocumentSubscription) {
            this.uploadMatterDocumentSubscription.unsubscribe();
        }
        if (this.pendingMatterSubscription) {
            this.pendingMatterSubscription.unsubscribe();
        }
        if (this.createInstructMatterSubscription) {
            this.createInstructMatterSubscription.unsubscribe();
        }
        if (this.historyUnlisten) {
            this.historyUnlisten();
        }
    }

    render() {    
        let routes = (
          <Switch>

            {/* <Route path="/testComponent" exact={true} component={TestComponentPage} /> */}
            
        <Route path="/notesSummary" exact={true} component={NotesSummaryPage} />

            <Route path="/marketingAutomation" exact={true} component={MarketingAutomationPage} />

            <Route path="/example/marketingAutomation" exact={true} component={SampleMarketingAutomationPage} />

            <Route path="/writeOffOnSummaryDrilldown" exact={true} component={WriteOffOnSummaryDrilldownPage} />

            <Route path="/unbilledFeeEarnerDrilldown" exact={true} component={UnbilledFeeEarnerDrilldownPage} />

            <Route path="/notesSummaryDrilldown" exact={true} component={NotesSummaryDrilldownPage} />

            <Route path="/generalMaterialConfiguration" exact={true} component={GeneralMaterialConfigurationPage} />

            <Route path="/clientDashboard" exact={true} component={ClientDashboardPage} />

            <Route path="/eventsAndCampaigns" exact={true} component={EventsAndCampaignsPage} />

            <Route path="/eventsAndCampaigns/attendee/:title/:id" exact={true} component={EventsAndCampaignsAttendeePage} />

            <Route path="/brandConfiguration" exact={true} component={BrandConfigurationPage} />

            <Route path="/taskDashboard" exact={true} component={TaskDashboardPage} />
            
            <Route path="/tasksSummaryDrilldown" exact={true} component={TaskSummaryDrilldownPage} />

            <Route path="/timesheetResourceCenter" exact={true} component={TimesheetResourceCenterPage} />

            <Route path="/timesheetResourceCenter/:command" exact={true} component={TimesheetResourceCenterPage} />

            <Route path="/taskResourceCenter" exact={true} component={TaskResourceCenterPage} />

            <Route path="/taskResourceCenter/:command" exact={true} component={TaskResourceCenterPage} />

            <Route path="/crmResourceCenter" exact={true} component={CrmResourceCenterPage} />

            <Route path="/resourceCenter/:command" exact={true} component={CrmResourceCenterPage} />

            <Route path="/acuityResourceCenter" exact={true} component={AcuityResourceCenterPage} />

            <Route path="/mattersResourceCenter" exact={true} component={MattersResourceCenterPage} />

            {/* <Route path="/learnMore" exact={true} component={LearnMorePage} /> */}
            <Route path="/learnMore/:command" exact={true} component={LearnMorePage} />
            
            <Route path="/invoiceSummary" exact={true} component={InvoiceSummaryPage} />

            <Route path="/userDashboard" exact={true} component={UserDashboard} />

            {/* help configuration */}
            <Route path="/helpConfiguration" exact={true} component={HelpConfigurationPage} />

            {/* user configuration */}
            <Route path="/userConfiguration" exact={true} component={UserConfigurationPage} />

            {/* referrers  page*/}
            <Route path="/referrers" exact={true} component={ReferrersPage} />

            {/* createEnquiry page */}
            <Route path="/createEnquiry" exact={true} component={CreateEnquiryPage} />

            {/* referrer details */}
            <Route path="/referrerDetails" exact={true} component={ClientAndContactDetails} />
            <Route path="/referrerDetails/" exact={true} component={ClientAndContactDetails} />
            <Route path="/referrerDetails/:id" exact={true} component={ClientAndContactDetails} />
            <Route path="/referrerDetails/:id/" exact={true} component={ClientAndContactDetails} />
            <Route path="/referrerDetails/:id/:tab" exact={true} component={ClientAndContactDetails} />

            {/* email templates */}
            <Route path="/emailConfiguration" exact={true} component={EmailTemplatesConfigurationPage} />
            <Route path="/emailConfiguration/:tab" exact={true} component={EmailTemplatesConfigurationPage} />

            {/* configuration */}
            <Route path="/lookupConfiguration" exact={true} component={LookupConfigurationPage} />
            <Route path="/lookupConfiguration/:tab" exact={true} component={LookupConfigurationPage} />
            <Route path="/lookupConfiguration/:tab/:command" exact={true} component={LookupConfigurationPage} />

            {/* integration */}
            <Route path="/integrationConfiguration" exact={true} component={IntegrationConfigurationPage} />
            <Route path="/integrationConfiguration/:tab" exact={true} component={IntegrationConfigurationPage} />
            <Route path="/integrationConfiguration/:tab/:command" exact={true} component={IntegrationConfigurationPage} />
            <Route path="/calendly/auth" exact={true} component={CalendlyAuthCallbackPage} />

            {/* integration */}
            <Route path="/firmSettingConfiguration" exact={true} component={FirmSettingConfigurationPage} />
            <Route path="/firmSettingConfiguration/:tab" exact={true} component={FirmSettingConfigurationPage} />
            <Route path="/firmSettingConfiguration/:tab/:command" exact={true} component={FirmSettingConfigurationPage} />

            {/* applciation settings */}
            <Route path="/applicationSettings" exact={true} component={ApplicationSettingsPage} />
            <Route path="/applicationSettings/:tab" exact={true} component={ApplicationSettingsPage} />
            <Route path="/applicationSettings/:tab/:command" exact={true} component={ApplicationSettingsPage} />

            {/* enquiry custom fields */}
            <Route path="/enquiryCustomFieldsConfiguration" exact={true} component={EnquiryCustomFieldsPage} />
            <Route path="/enquiryCustomFieldsConfiguration/:tab" exact={true} component={EnquiryCustomFieldsPage} />
            <Route path="/enquiryCustomFieldsConfiguration/:tab/:command" exact={true} component={EnquiryCustomFieldsPage} />

            {/* firm structure configuration */}
            <Route path="/firmStructureConfiguration" exact={true} component={FirmStructureConfigurationPage} />
            <Route path="/firmStructureConfiguration/:tab" exact={true} component={FirmStructureConfigurationPage} />
            <Route path="/firmStructureConfiguration/:tab/:command" exact={true} component={FirmStructureConfigurationPage} />

            {/* taskflow builder */}
            <Route path="/taskflowConfiguration" exact={true} component={TaskflowBuilderPage} />

            <Route path="/lawyerDashboard" exact={true} component={LawyerDashboardPage} />
            <Route path="/timeslip" exact={true} component={TimeslipPage} />
            <Route path="/matterDetail" exact={true} component={MatterDetails} />        
            <Route path="/matterDetail/" exact={true} component={MatterDetails} />        
            <Route path="/matterDetail/:id" exact={true} component={MatterDetails} />
            <Route path="/matterDetail/:id/" exact={true} component={MatterDetails} />
            <Route path="/matterDetail/:id/:tab" exact={true} component={MatterDetails} />
            <Route path="/matterSummary" exact={true} component={MatterSummary} />
            <Route path="/matterSummaryDrillDown" exact={true} component={MatterSummaryDrillDown} />
            <Route path="/matterManagement" exact={true} component={MatterManagementPage} />
            <Route path="/clientsAndContacts" exact={true} component={NameSummaryPage} />
            <Route path="/timesheet" exact={true} component={TimesheetPage} />
            <Route path="/staffSummary" exact={true} component={StaffSummaryPage} />
            <Route path="/userDashboard" exact={true} component={UserDashboard} />
            <Route path="/reports" exact={true} component={ReportsPage} />
            <Route path="/reports/viewer/:id/:command" exact={true} component={ReportViewer} />
            <Route path="/reports/info/:id" exact={true} component={ReportInformation} />
            <Route path="/reportsCatalog" exact={true} component={ReportsCatalogPage} />
            <Route path="/reportsCatalog/info/:id" exact={true} component={ReportCatalogInformation} />

            <Route path="/clientAndContactDetail" exact={true} component={ClientAndContactDetails} />
            <Route path="/clientAndContactDetail/" exact={true} component={ClientAndContactDetails} />
            <Route path="/clientAndContactDetail/:id" exact={true} component={ClientAndContactDetails} />
            <Route path="/clientAndContactDetail/:id/" exact={true} component={ClientAndContactDetails} />
            <Route path="/clientAndContactDetail/:id/:tab" exact={true} component={ClientAndContactDetails} />
            <Route path="/unauthorised" exact={true} component={Unauthorised} />

            <Route path="/feeEarnerDashboard" exact={true} component={FeeEarnerDashboardPage} />
            <Route path="/feeEarnerDashboard/leap" exact={true} component={FeeEarnerDashboardPage} />
            
            <Route 
                path="/dashboardLayoutConfiguration" 
                exact={true} 
                render={(props) => <FeatureLayoutConfigurationPage {...props as any} />}
            />         
            <Route path="/splashScreenConfiguration" exact={true} component={SplashScreenConfigurationPage} />
            <Route path="/featureLicenceConfiguration" exact={true} component={FeatureLicenceConfigurationPage} />
            <Route path="/featureAccessConfiguration" exact={true} component={FeatureAccessConfigurationPage} />
            <Route path="/configurationDashboard" exact={true} component={ConfigurationDashboardPage} />
            <Route path="/matterManagement" exact={true} component={MatterManagementPage} />
            <Route path="/roleSecurityConfiguration" exact={true} component={RoleSecurityConfigurationPage} />
            <Route path="/matterViewColumnSecurityConfiguration" exact={true} component={MatterColumnSecurityConfigurationPage} />

            <Route 
                path="/matterSummary/:command" 
                exact={true} 
                render={(props) => <MatterSummary {...props} />}
            />
            
            <Route path="/LeapSignIn" exact={true} component={LeapSignIn} />    
            <Route path="/LeapAccessResetSignIn" exact={true} component={LeapAccessResetSignIn} />    
            <Route path="/LeapProvisioning/" exact={true} component={LeapProvisioning} />
            <Route path="/LeapAccessReset" exact={true} component={LeapAccessReset} />    
            <Route path="/LeapProvisioningInProgress/" exact={true} component={LeapProvisioningInProgress} />
            <Route path="/SmokeballSignIn" exact={true} component={SmokeballSignIn} />    
            <Route path="/SmokeballAccessResetSignIn" exact={true} component={SmokeballAccessResetSignIn} />    
            <Route path="/SmokeballProvisioning/" exact={true} component={SmokeballProvisioning} />
            <Route path="/SmokeballAccessReset" exact={true} component={SmokeballAccessReset} />    
            <Route path="/SmokeballProvisioningInProgress/" exact={true} component={SmokeballProvisioningInProgress} />
            <Route path="/ActionStepSignIn" exact={true} component={ActionStepSignIn} />    
            <Route path="/ActionStepAccessResetSignIn" exact={true} component={ActionStepAccessResetSignIn} />    
            <Route path="/ActionStepProvisioning/" exact={true} component={ActionStepProvisioning} />
            <Route path="/ActionStepAccessReset" exact={true} component={ActionStepAccessReset} />    
            <Route path="/ActionStepProvisioningInProgress/" exact={true} component={ActionStepProvisioningInProgress} />
            <Route path="/AffinitySignIn" exact={true} component={AffinitySignIn} />    
            <Route path="/AffinityAccessResetSignIn" exact={true} component={AffinityAccessResetSignIn} />    
            {/* <Route path="/AffinityProvisioning/" exact={true} component={AffinityProvisioning} /> */}
            <Route path="/AffinityAccessReset" exact={true} component={AffinityAccessReset} />    
            <Route path="/AffinityProvisioningInProgress/" exact={true} component={AffinityProvisioningInProgress} />
            <Route path="/matterSummary/list/print" exact={true} component={RvPrint} />
            <Route path="/matterSummary/list/print2" exact={true} component={RvPrint2} />
            <Route path="/dashboard2" exact={true} component={Dashboard} />
            <Route path="/dashboardOld" exact={true} component={RvDashboardOld} />
            <Route path="/dashboard" exact={true} component={Home} />
            <Route path="/dashboard/leap" exact={true} component={Home} />
            <Route path="/admin" exact={true} component={RvAdminDashboard} />
            <Route path="/admin/userList" exact={true} component={UserListPage} />
            <Route path="/admin/userList/:command" exact={true} component={UserListPage} />
            <Route path="/enquiriesSummary" exact={true} component={EnquirySummaryPage} />
            <Route path="/enquiriesSummary/leap" exact={true} component={EnquirySummaryPage} />
            <Route path="/enquiriesDetail/:id" exact={true} component={LeadsDetailPage} />
            <Route path="/enquiriesSummary/:id" exact={true} component={EnquirySummaryPage} />
            <Route path="/enquiriesDashboard" exact={true} component={LeadsDashboardPage} />
            <Route path="/tasksSummary" exact={true} component={TasksSummaryPage} />
            <Route path="/tasksSummary/:id/:taskType" exact={true} component={TasksSummaryPage} />
            <Route path="/tasksSummary/:id" exact={true} component={TasksSummaryPage} />
            <Route path="/mailingList" exact={true} component={MailingListPage} />

            <Route path="/enquiriesDashboard/leap" exact={true} component={LeadsDashboardPage} />
            <Route path="/clientsAndContacts/leap" exact={true} component={NameSummaryPage} />
            <Route path="/referrers/leap" exact={true} component={ReferrersPage} />
            <Route path="/MailingList/leap" exact={true} component={MailingListPage} />
            <Route path="/GeneralMaterial" exact={true} component={GeneralMaterialPage}  />
            <Route path="/clientDocuments" exact={true} component={ClientDocumentsPage}  />

            <Route 
                path="/admin/chart/userAIActivity" 
                exact={true} 
                component={UserAIActivityChartPage} 
            />
            <Route 
                path="/admin/userAIActivity" 
                exact={true} 
                component={UserAIActivitytPage} 
            /> 
            <Route 
                path="/admin/userAIActivity/:command" 
                exact={true} 
                component={UserAIActivitytPage} 
            />
            <Route 
                path="/admin/userAIActivity/:filter/:command" 
                exact={true} 
                component={UserAIActivitytPage} 
            /> 
            <Route 
                path="/admin/chart/emailFailures" 
                exact={true} 
                component={EmailSendFailureChartPage} 
            />
            <Route 
                path="/admin/emailFailures" 
                exact={true} 
                component={EmailSendFailurePage} 
            /> 
            <Route 
                path="/admin/emailFailures/:command" 
                exact={true} 
                component={EmailSendFailurePage} 
            />
            <Route 
                path="/admin/emailFailures/:filter/:command" 
                exact={true} 
                component={EmailSendFailurePage} 
            /> 
            <Route 
                path="/admin/chart/matterAccess" 
                exact={true} 
                component={MatterAccessChartPage} 
            />
            <Route 
                path="/admin/matterAccess" 
                exact={true} 
                component={MatterAccessPage} 
            /> 
            <Route 
                path="/admin/matterAccess/:command" 
                exact={true} 
                component={MatterAccessPage} 
            />
            <Route 
                path="/admin/matterAccess/:filter/:command" 
                exact={true} 
                component={MatterAccessPage} 
            />                        
            <Route 
                path="/admin/nameAccess" 
                exact={true} 
                component={NameAccessPage} 
            /> 
            <Route 
                path="/admin/nameAccess/:command" 
                exact={true} 
                component={NameAccessPage} 
            />
            <Route 
                path="/admin/nameAccess/:filter/:command" 
                exact={true} 
                component={NameAccessPage} 
            />
            <Route 
                path="/admin/chart/nameAccess" 
                exact={true} 
                component={NameAccessChartPage} 
            />

            <Route 
                path="/admin/marketingListAccess" 
                exact={true} 
                component={MarketingListAccessPage} 
            /> 
            <Route 
                path="/admin/marketingListAccess/:command" 
                exact={true} 
                component={MarketingListAccessPage} 
            />
            <Route 
                path="/admin/marketingListAccess/:filter/:command" 
                exact={true} 
                component={MarketingListAccessPage} 
            />

            <Route 
                path="/admin/chart/marketingListAccess" 
                exact={true} 
                component={MarketingListAccessChartPage} 
            />

            <Route 
                path="/admin/loginActivity" 
                exact={true} 
                component={LoginActivityPage} 
            /> 
            <Route 
                path="/admin/loginActivity/:command" 
                exact={true} 
                component={LoginActivityPage} 
            />
            <Route 
                path="/admin/loginActivity/:filter/:command" 
                exact={true} 
                component={LoginActivityPage} 
            />
            
            <Route 
                path="/admin/matterPublishingRules" 
                exact={true} 
                component={MatterPublishingRulesPage} 
            /> 
            <Route 
                path="/admin/matterPublishingRules/:command" 
                exact={true} 
                component={MatterPublishingRulesPage} 
            />
            <Route 
                path="/admin/matterPublishingRules/:filter/:command" 
                exact={true} 
                component={MatterPublishingRulesPage} 
            />

            <Route 
                path="/admin/smsUsageLogging" 
                exact={true} 
                component={SmsUsageLoggingPage} 
            /> 
            <Route 
                path="/admin/smsUsageLogging/:command" 
                exact={true} 
                component={SmsUsageLoggingPage} 
            />
            <Route 
                path="/admin/smsUsageLogging/:filter/:command" 
                exact={true} 
                component={SmsUsageLoggingPage} 
            />

            <Route
                path="/admin/chart/smsUsageLogging"
                exact={true}
                component={SmsUsageLoggingChartPage}
            />

            <Route
                path="/admin/emailSendLogging"
                exact={true}
                component={EmailSendLoggingPage}
            />
            <Route
                path="/admin/emailSendLogging/:command"
                exact={true}
                component={EmailSendLoggingPage}
            />

            <Route 
                path="/admin/dashboardActivity" 
                exact={true} 
                component={UserDashboardActivityListPage} 
            /> 

            <Route 
                path="/admin/outlookAddinUsage" 
                exact={true} 
                component={UserOutlookAddinUsagePage} 
            /> 

            <Route 
                path="/admin/chart/loginActivity" 
                exact={true} 
                component={LoginActivityChartPage} 
            />
            <Route 
                path="/admin/chart/dashboardAccess" 
                exact={true} 
                component={DashboardAccessPage} 
            />
            <Route 
                path="/admin/chart/outlookAddinUsage" 
                exact={true} 
                component={OutlookAddinUsagePage} 
            />
            <Route 
                path="/timesheetDrilldown" 
                exact={true} 
                component={TimesheetDrilldownPage} 
            /> 

            <Route 
                path="/staffBillingSummaryDrilldown" 
                exact={true} 
                component={StaffBillingSummaryPage} 
            />
            
            <Route 
                path="/admin/timesheetActivity" 
                exact={true} 
                component={TimesheetActivityPage} 
            />  
            <Route 
                path="/admin/timesheetActivity/:command" 
                exact={true} 
                component={TimesheetActivityPage} 
            />
            <Route 
                path="/admin/timesheetActivity/:filter/:command" 
                exact={true} 
                component={TimesheetActivityPage} 
            />
            <Route 
                path="/admin/chart/timesheetActivity" 
                exact={true} 
                component={TimelinesChartPage} 
            />                     
            <Route path="/admin/messageActivity" exact={true} component={MessageActivityPage} />
            <Route path="/admin/messageActivity/:command" exact={true} component={MessageActivityPage} />
            <Route path="/admin/roleSummary" exact={true} component={RoleSummaryPage} /> 
            <Route path="/admin/roleSummary/:command" exact={true} component={RoleSummaryPage} />   
            <Route path="/settings" exact={true} component={Settings} />
            <Route path="/login" exact={true} component={Redirect} />
            {/* <Route path="/autoSignIn/:token/:redirectUrl" exact={true} component={AutoSignIn} /> */}
            <Route path="/autoSignIn" exact={true} component={AutoSignIn} />
            <Route path="/externalEnquiry" exact={true} component={ExternalEnquiry} />
            <Route 
                path="/ClientService" 
                exact={true} 
                // tslint:disable-next-line:max-line-length
                component={() => { window.location.href = 'https://www.redraincorp.com/features-1/#staff-mobility'; return null; }} 
            />
            <Route 
                path="/clientsense"  
                exact={true} 
                // render={(props) => {
                //   // let url = { params: { url: 'http://clientsense/app/RelationshipManagement' } };
                //   let url = { params: { url: 'https://prodredviewaus.blob.core.windows.net/images/ClientSense.PNG' } };
                //   return <UrlViewer match={url}/>;
                // }}
                component={() => { 
                // tslint:disable-next-line
                // eslint-disable-next-line jsx-a11y/alt-text
                return <img 
                            src="https://prodredviewaus.blob.core.windows.net/images/ClientSense.PNG" 
                            style={{width: '70%', height: 'auto', marginLeft: 'auto', marginRight: 'auto', display: 'block'}} 
                        // tslint:disable-next-line:jsx-alignment
                        />; 
                    }} 
            />
            <Route 
                path="/innography"  
                exact={true} 
                render={(props) => {
                let url = { params: { url: 'https://app.innography.com/' } };
                return <UrlViewer match={url}/>;
                }}
            />
            <Route
                path="/:tenantId"
                exact={true}
                render={(props) => <Login
                                    onLogin={this.onLogin}
                                    onTenant={this.onTenant}
                                    onRequestSupport={this.onRequestSupport}
                                    {...props as any}
                                    // tslint:disable-next-line:jsx-alignment
                                    />
                        }
            />
            {/* <Route path="/:tenantId" exact={true} component={Login} /> */}
            <Route
                path="/:tenantId/login"
                exact={true}
                render={(props) => (<Login
                                    onLogin={this.onLogin}
                                    onTenant={this.onTenant}
                                    onRequestSupport={this.onRequestSupport}
                                    {...props as any}
                                    // tslint:disable-next-line:jsx-alignment
                                    />)
                        }
            />
            <Route
                path="/:tenantId/verify/:verificationCode"
                exact={true}
                render={(props) => (<VerifyNewUser
                                    onTenant={this.onTenant}
                                    {...props as any}
                                    // tslint:disable-next-line:jsx-alignment
                                    />)}
            />
            <Route
                path="/:tenantId/logout"
                exact={true}
                render={(props) => <Logout onLogout={this.onLogout} {...props as any} />}
            />
            <Route
                path="/logout"
                exact={true}
                render={(props) => <Logout onLogout={this.onLogout} {...props as any} />}
            />          
            <Route path="/" exact={true} component={Redirect} />
            {/*   <Route component={Redirect}/> */}

            <Route path="/externalAccess/validate" exact={true} component={ExternalAccessValidation} />

            <Route
                path="/externalAccess/enquiryDataCollectionForm/:enquiryGuid"
                exact={true}
                render={(props) => (
                    <EnquiryDataCollectionFormPage
                        {...props}
                        tenantId={this.state.tenantId}
                        isAuthenticated={this.state.isAuthenticated}
                    />
                )}
            />

            {/* <Route
                path="/external/enquiryDataCollectionForm"
                exact={true}
                render={(props) => <EnquiryDataCollectionFormPage {...props} tenantId={this.state.tenantId} isAuthenticated={this.state.isAuthenticated} />}
            /> */}

          </Switch>
        );

        // eslint-disable-next-line
        let hideHeadFooter = location.pathname.toLowerCase() === '/leapprovisioninginprogress' 
                                  || location.pathname.toLowerCase() === '/leapprovisioning'
                                  || location.pathname.toLowerCase() === '/leapaccessreset'
                                  || location.pathname.toLowerCase() === '/feeearnerdashboard/leap'
                                  || location.pathname.toLowerCase() === '/dashboard/leap'
                                  || location.pathname.toLowerCase() === '/autosignin'
                                  || location.pathname.toLowerCase() === '/externalenquiry'
                                  || location.pathname.toLowerCase() === '/enquiriessummary/leap'
                                  || location.pathname.toLowerCase() === '/enquiriesdashboard/leap'
                                  || location.pathname.toLowerCase() === '/clientsandcontacts/leap'
                                  || location.pathname.toLowerCase() === '/referrers/leap'
                                  || location.pathname.toLowerCase() === '/mailinglist/leap'
                                  || location.pathname.toLowerCase() === '/smokeballprovisioninginprogress' 
                                  || location.pathname.toLowerCase() === '/smokeballprovisioning'
                                  || location.pathname.toLowerCase() === '/smokeballaccessreset'
                                  || location.pathname.toLowerCase() === '/actionstepprovisioninginprogress' 
                                  || location.pathname.toLowerCase() === '/actionstepprovisioning'
                                  || location.pathname.toLowerCase() === '/actionstepaccessreset';

        let noHeaderAndFooterRoute = location.pathname.includes('/timeslip')
                                            || location.pathname.includes('/createEnquiry')
                                            || location.pathname.startsWith('/externalAccess/');

        // The login page (see Login.tsx) renders its own logo, "Get Support" link, and
        // copyright/footer line in-column per the login redesign, so the global header/footer
        // would otherwise duplicate them.
        // Guarded on !isAuthenticated: '/:tenantId' alone matches the shape of nearly every
        // authenticated page (e.g. '/dashboard', '/admin'), so without this every page's
        // header would be wrongly treated as the login route.
        let isLoginRoute = !this.state.isAuthenticated
                                && (!!matchPath(location.pathname, { path: '/:tenantId', exact: true })
                                    || !!matchPath(location.pathname, { path: '/:tenantId/login', exact: true }));

        var appHeader = hideHeadFooter || noHeaderAndFooterRoute || isLoginRoute
            ? null
            : (
              <AppHeader
                key={this.getAppHeaderKey()}
                tenantId={this.state.tenantId}
                isAuthenticated={this.state.isAuthenticated}
                onToggleMenu={this.onShowMenu}
                isForceToChangePass={this.state.isForceToChangePass}
                onUploadDocuments={this.onUploadDocuments}
                onRequestSupport={this.onRequestSupport}
                onClickInstructMatter={this.onClickInstructMatter}
                onToggleDrawer={this.onToggleDrawer}
                onToggleQuickView={this.onToggleQuickView}
                dockMode={this.state.dockMode}
                onCycleDock={this.onCycleDock}
                onCloseDock={this.onCloseDock}
                isMenuOpen={this.state.showMenu}
              />
        );

        // Same leftInset calc this render's own AiChatMinimizedBar already uses below - follows
        // the sidebar's own current dock width instead of a fixed value, so the footer's
        // copyright text lines up with the page content regardless of dock state.
        var appFooter = hideHeadFooter || noHeaderAndFooterRoute || isLoginRoute ? null : (
            <AppFooter
                leftInset={
                    this.state.dockMode === 'full' ? FULL_WIDTH
                        : this.state.dockMode === 'semi' ? SEMI_WIDTH
                            : '0px'
                }
            />
        );

        var mainClass = hideHeadFooter || noHeaderAndFooterRoute || isLoginRoute ? '' : 'custom-site-content';

        return (
            <ThemeProvider theme={mainTheme}>
              <AiDocumentChatProvider>
                <SiteParent className={this.state.isPrint ? 'site-onprint' : ''}>
                    {/* Only rendered when there's an actual header - the SiteParent '& > .header'
                        rule above sizes/positions this element unconditionally (position:fixed,
                        height:HEADER_HEIGHT, white background), so an empty <header> still shows
                        as a blank bar. The 'timesip-lheader' class here was meant to suppress
                        that (display:none via '& .timeslip-header' above), but the class name
                        doesn't match the CSS selector, so it never applied - conditionally
                        rendering the element itself is the fix, for every appHeader===null case
                        (hideHeadFooter/noHeaderAndFooterRoute/isLoginRoute), not just login. */}
                    {appHeader && (
                        <header className="header">
                            {appHeader}
                        </header>
                    )}
                    <NotificationSystem
                        ref={this.props.notificationSystem}
                    />
                    {this.state.isAuthenticated && <AiChatDialogRoot />}
                    <main
                        className={`Site-content ${mainClass}`}
                        style={{
                            paddingBottom: noHeaderAndFooterRoute ? 0 : '15px',
                            flex: 1,
                            display: 'flex',
                            flexDirection: 'column',
                            minHeight: 0,
                            // Pinned Quick View (userDashboard/quickView/QuickViewDrawer.tsx)
                            // renders as an actual docked panel (variant="permanent", flex:0 0
                            // auto) rather than an overlay - this margin is what makes the rest
                            // of the app's content move over to make room for it, the same way
                            // AppMenu.tsx's own docked sidebar pushes this same <main> over from
                            // the other side (that one via its own internal flex layout, this one
                            // via margin since the drawer isn't nested inside <main>).
                            marginRight: this.state.isAuthenticated && this.state.isQuickViewOpen && this.state.isQuickViewPinned
                                ? QUICK_VIEW_WIDTH
                                : 0,
                            transition: 'margin-right 0.25s ease',
                        }}
                    >
                        <Router history={browserHistory}>
                            <div className="site-child" style={{ flex: 1, display: 'flex', flexDirection: 'column', minHeight: 0 }}>
                              {location.pathname.startsWith('/externalAccess/')
                                ? <div style={{ minHeight: '100vh', width: '100%', display: 'flex', flexDirection: 'column' }}>{routes}</div>
                                : <AppMenu show={this.state.isAuthenticated && (this.state.dockMode !== 'closed' || this.state.showMenu)} handleSidebarHide={this.onMenuClose} dockMode={this.state.isAuthenticated ? this.state.dockMode : 'closed'} onCycleDock={this.onCycleDock}>{routes}</AppMenu>
                              }
                            </div>
                        </Router>
                        {this.state.isAuthenticated && (
                            <AiChatMinimizedBar
                                leftInset={
                                    this.state.dockMode === 'full' ? FULL_WIDTH
                                        : this.state.dockMode === 'semi' ? SEMI_WIDTH
                                            : '0px'
                                }
                                rightInset={this.state.isQuickViewOpen && this.state.isQuickViewPinned ? `${QUICK_VIEW_WIDTH}px` : '0px'}
                            />
                        )}
                    </main>
                    <footer>
                        {appFooter}
                    </footer>
                    {UserFeature.HasAccess(UserFeatureEnum.hasUploadMatterDocument) && this.state.isUploadDialogOpen && (
                        <UploadDocumentDialog 
                            onClose={this.onUploadClose}                          
                        />
                    )}
                    {this.state.isSupportDialogOpen && (
                        <SupportEmailDialog
                            isAuthenticated={this.state.isAuthenticated}
                            onClose={this.onRequestSupportClose}
                            initialNote={this.state.supportDialogInitialNote}
                            customization={this.state.supportDialogCustomization}
                        />
                    )}
                    {this.state.isInstructMatterDialogOpen && (
                        <InstructMatterFormDialog 
                            open={this.state.isInstructMatterDialogOpen}
                            onClose={this.onInstructMaterClose}
                        />
                    )}
                    {this.state.isTimerDrawerOpen && (
                        <TimesheetTimerDrawer
                            onClose={this.onToggleDrawer}
                            open={this.state.isTimerDrawerOpen}
                        />
                    )}
                    {/* Explicit bug report: isQuickViewOpen alone auto-reopens from the
                        persisted pin preference (see the constructor's own isQuickViewPinned
                        seed) regardless of auth state, so on the login screen - reached after
                        a previous session had it pinned, since nothing clears that preference
                        on logout - this mounted anyway and crashed the page (its widgets all
                        assume an authenticated session). Gated on isAuthenticated too, same as
                        every other conditionally-mounted piece of chrome here (appHeader,
                        UploadDocumentDialog, etc.) - never rendered until actually logged in,
                        and unmounts immediately on logout even if it was open/pinned. */}
                    {this.state.isAuthenticated && this.state.isQuickViewOpen && (
                        <QuickViewDrawer
                            onClose={this.onToggleQuickView}
                            open={this.state.isQuickViewOpen}
                            isPinned={this.state.isQuickViewPinned}
                            onTogglePin={this.onToggleQuickViewPin}
                            isTourRunning={this.state.isQuickViewTourRunning}
                        />
                    )}
                    {/* The Quick View tour: opens by itself the first time (see QuickViewTourController), and from the ? in the panel's header. */}
                    {this.state.isAuthenticated && !location.pathname.startsWith('/externalAccess/') && (
                        <QuickViewTourController
                            isAuthenticated={this.state.isAuthenticated}
                            isQuickViewOpen={this.state.isQuickViewOpen}
                            onToggleQuickView={this.onToggleQuickView}
                            onRunningChange={this.onQuickViewTourRunningChange}
                        />
                    )}
                    {this.state.isAuthenticated && !location.pathname.startsWith('/externalAccess/') && <SessionExpiryWarningDialog />}
                </SiteParent>
              </AiDocumentChatProvider>
            </ThemeProvider>
        );
    }

    private subscribeToUploadMatterDocument() {      
        // let vm = this;
        this.uploadMatterDocumentSubscription = client.subscribe({
            query: UploadMatterDocumentNotification
        }).subscribe({
            // tslint:disable-next-line:no-any
            next(results: any) {
                // tslint:disable-next-line:no-console
                console.log(results);
                if (results.data.uploadMatterDocumentNotification.status) {
                    showNotification('Success', results.data.uploadMatterDocumentNotification.message, 'info');

                    // vm.setState({
                    //     isUploadDialogOpen: false
                    // });

                } else {
                    showNotification('Failed', results.data.uploadMatterDocumentNotification.message, 'error');
                }
            },            
            // tslint:disable-next-line:no-any
            error(err: any) {
                // tslint:disable-next-line:no-console
                console.error(err);
                showNotification(null, err, 'error');
            }
        });
    }

    private subscribePendingMatter() {
        this.pendingMatterSubscription = client.subscribe({
            query: CreatePendingMattersSubscription
        }).subscribe({
            // tslint:disable-next-line:no-any
            next(results: any) {
                // tslint:disable-next-line:no-console
                console.log(results);
                if (results.data.createPendingMatterNotification.status) {
                    showNotification('Success', results.data.createPendingMatterNotification.message, 'info');

                } else {
                    showNotification('Failed', results.data.createPendingMatterNotification.message, 'error');
                }
            },            
            // tslint:disable-next-line:no-any
            error(err: any) {
                // tslint:disable-next-line:no-console
                console.error(err);
                showNotification(null, err, 'error');
            }
        });
    }

    private subscribeInstructMatter() {
        this.pendingMatterSubscription = client.subscribe({
            query: CreateInstructMatterSubscription
        }).subscribe({
            // tslint:disable-next-line:no-any
            next(results: any) {
                // tslint:disable-next-line:no-console
                console.log(results);
                if (results.data.createInstructMatterNotifications.status) {
                    showNotification('Success', results.data.createInstructMatterNotifications.message, 'info');

                } else {
                    showNotification('Failed', results.data.createInstructMatterNotifications.message, 'error');
                }
            },            
            // tslint:disable-next-line:no-any
            error(err: any) {
                // tslint:disable-next-line:no-console
                console.error(err);
                showNotification(null, err, 'error');

                close();
            }
        });
    }

    private onUploadDocuments() {
        this.setState({
            isUploadDialogOpen: true
        });
    }

    private onUploadClose() {
        
        this.setState({
            isUploadDialogOpen: false
        });
    }

    private onRequestSupport(initialNote?: string, customization?: SupportDialogCustomization) {
        this.setState({
            isSupportDialogOpen: true,
            supportDialogInitialNote: initialNote || '',
            supportDialogCustomization: customization
        });
    }

    private onRequestSupportClose() {

        this.setState({
            isSupportDialogOpen: false,
            supportDialogInitialNote: '',
            supportDialogCustomization: undefined
        });
    }

    private onLogin( loggedIn: boolean) {
        // set the callback
        // history.push('/mattersSummary');
        this.setState({isAuthenticated: loggedIn});
        // if (this.props.history) { this.props.history.push('/mattersSummary'); }

        if (loggedIn) {
            if (!this.isSubscribed) {
                this.isSubscribed = true;
                this.subscribeToUploadMatterDocument();
            }
            
            this.getDefaultSetting();
            this.getDefaultApplicationTerminology();
        }       
    }

    private onLogout( ) {
      this.setState({isAuthenticated: false, showMenu: false});
    }

    private onTenant( tenantId: string) {
        // set the callback
        this.setState({tenantId: tenantId});
    }  

    private onShowMenu( show: boolean) {
        this.setState({showMenu: show});
    }

    private onCycleDock() {
        const next: Record<string, 'closed' | 'full' | 'semi'> = {
            closed: 'full',
            full:   'semi',
            semi:   'closed',
        };
        const dockMode = next[this.state.dockMode] || 'closed';
        localStorage.setItem('appMenuDock', dockMode);
        this.setState({ dockMode, showMenu: dockMode !== 'closed' });
    }

    private onCloseDock() {
        localStorage.setItem('appMenuDock', 'closed');
        this.setState({ dockMode: 'closed', showMenu: false });
    }

    private onMenuClose() {
        this.setState({ showMenu: false });
    }

    private getAppHeaderKey() {
        return this.state.isAuthenticated ? this.authenticatedUserKey : this.unAuthenticatedUserKey;
    }

    private onClickInstructMatter() {
        this.setState({
            isInstructMatterDialogOpen: true
        });
    }

    private onInstructMaterClose() {
        this.setState({
            isInstructMatterDialogOpen: false
        });
    }

    private onToggleDrawer() {
        this.setState({
            isTimerDrawerOpen: !this.state.isTimerDrawerOpen
        });
    }

    private onToggleQuickView() {
        const isQuickViewOpen = !this.state.isQuickViewOpen;

        // Explicit request: closing a pinned panel (this same toggle also fires from
        // QuickViewDrawer's own ✕ button, see that prop below) now undocks it too, so it
        // doesn't silently reopen pinned on the next refresh - this constructor's own
        // isQuickViewOpen seed reads the persisted 'quickViewPinned' preference alone,
        // with no way to tell "still pinned" apart from "was pinned, then closed last
        // session". Previously only the pin/unpin button itself cleared that preference -
        // see QuickViewDrawer.tsx's isQuickViewCurrentlyDocked comment for the old
        // "closing never resets it" rationale this replaces. Only applies to the
        // open->closed transition - opening from the header icon never touches pin state.
        if (!isQuickViewOpen && this.state.isQuickViewPinned) {
            localStorage.setItem('quickViewPinned', 'false');
            this.setState({ isQuickViewOpen, isQuickViewPinned: false });
            return;
        }

        this.setState({ isQuickViewOpen });
    }

    // Pinning always leaves it open (there's no "pin while closed" gesture - the pin button
    // only exists in the panel's own header). Unpinning switches it back to a temporary
    // overlay rather than closing it outright - same "unpin ≠ close" distinction the ✕ button
    // vs this one draw for the nav sidebar's own dockMode.
    private onQuickViewTourRunningChange(isQuickViewTourRunning: boolean) {
        if (this.state.isQuickViewTourRunning !== isQuickViewTourRunning) {
            this.setState({ isQuickViewTourRunning });
        }
    }

    private onToggleQuickViewPin() {
        const isQuickViewPinned = !this.state.isQuickViewPinned;
        localStorage.setItem('quickViewPinned', isQuickViewPinned ? 'true' : 'false');
        // QuickViewDrawer.tsx's own effect (watching its isPinned prop) is what actually
        // notifies useIsQuickViewPinned()'s subscribers elsewhere in the app - nothing to
        // broadcast from here, this state change alone is enough to trigger that.
        this.setState({ isQuickViewPinned, isQuickViewOpen: true });
    }

    private getDefaultSetting() {
        client.query<DefaultSettingsData>({
            query: DefaultSettingQuery,
            fetchPolicy: 'cache-first'
            // tslint:disable-next-line:no-any
        }).then((results: ApolloQueryResult<DefaultSettingsData>) => {    
                
                if (
                    results.data &&
                    results.data.settings &&
                    results.data.settings.systems &&
                    results.data.settings.systems.regionSettings &&
                    results.data.settings.systems.regionSettings.config
                ) {
                    const { homeCountry } = results.data.settings.systems.regionSettings.config;

                    let lang = undefined;

                    if (homeCountry) {
                        lang = getLanguageCodeByCountry(homeCountry.toUpperCase() as any);
                    } else {
                        lang = getLanguageCodeByCountry('AU');
                    }

                    i18n.changeLanguage(lang);
                }
                
                if (results.data && results.data.settings.applications && results.data.settings.applications.labelSettings) {
                    
                    const { personActingLabel, personResponsibleLabel, matterAssistingResponsibilityLabel, matterIntroducingResponsibilityLabel } = results.data.settings.applications.labelSettings.config;

                    if (personActingLabel) {
                        localStorage.setItem(LocalStorageEnum.PersonActing, personActingLabel);
                    } else {
                        localStorage.setItem(LocalStorageEnum.PersonActing, 'Person Acting');
                    }

                    if (personResponsibleLabel) {
                        localStorage.setItem(LocalStorageEnum.PersonResponsible, personResponsibleLabel);
                    } else {
                        localStorage.setItem(LocalStorageEnum.PersonResponsible, 'Person Responsible');
                    }
                    
                    if (matterAssistingResponsibilityLabel) {
                        localStorage.setItem(LocalStorageEnum.MatterAssistingResponsibility, matterAssistingResponsibilityLabel);
                    } else {
                        localStorage.setItem(LocalStorageEnum.MatterAssistingResponsibility, 'Person Assisting');
                    }

                    if (matterIntroducingResponsibilityLabel) {
                        localStorage.setItem(LocalStorageEnum.MatterIntroducingResponsibility, matterIntroducingResponsibilityLabel);
                    } else {
                        localStorage.setItem(LocalStorageEnum.MatterIntroducingResponsibility, 'Introducer');
                    }

                }

            // tslint:disable-next-line:no-any
            }).catch((reason: any) => {
                showNotification(null, reason, 'error');
        });
    }

    private getDefaultApplicationTerminology() {
        client.query<ApplicationTerminologyData>({
            query: ApplicationTerminoLogyQuery,
            fetchPolicy: 'cache-first'
        }).then((results) => {
            if (results.data.lookup.applicationTerminology) {
                localStorage.setItem(LocalStorageEnum.ApplicationTerminology, JSON.stringify(results.data.lookup.applicationTerminology));
            }
        });
    }
}

type DefaultSettingsData = {
    settings: Settings;
};

type Settings = {
    id:           number;
    systems:      Systems;
    applications: Applications;
};

type Applications = {
    labelSettings: LabelSettings;
};

type LabelSettings = {
    config: LabelSettingsConfig;
};

type LabelSettingsConfig = {
    personActingLabel:      string;
    personResponsibleLabel: string;
    matterAssistingResponsibilityLabel: string;
    matterIntroducingResponsibilityLabel: string;
};

type Systems = {
    id:             number;
    regionSettings: RegionSettings;
};

type RegionSettings = {
    id:     number;
    config: RegionSettingsConfig;
};

type RegionSettingsConfig = {
    id:          number;
    homeCountry: string;
};

const DefaultSettingQuery = gql`
    query DefaultSettingQuery {
        settings {
            id
            systems {
                id
                regionSettings {
                    id
                    config {
                        id
                        homeCountry
                    }
                }
            }
            applications {
                labelSettings {
                    config {
                        personActingLabel
                        personResponsibleLabel
                        matterAssistingResponsibilityLabel
                        matterIntroducingResponsibilityLabel
                    }
                }
            }
        }
    }
`;